import { SUCCESS } from '../../../../constants/action-postfix'
import { EDU_COMMISSIONS_LIST_REQUEST } from '../eduCommissionsActionTypes'

const initialState = []

export const eduCommissionsListReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${EDU_COMMISSIONS_LIST_REQUEST}${SUCCESS}`:
      return action.payload

    default:
      return state
  }
}
